"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownOption = exports.Dropdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../../../BootstrapHelper");
var react_1 = __importStar(require("react"));
var Panel_1 = require("../../../ui/Panel");
var IconSymbols_1 = require("../../../generated/IconSymbols");
var Icon_1 = require("../../../ui/Icon");
var enums_1 = require("../../../enums");
var Dropdown = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("dropdown")
        .pmod(props.disabled ? "disabled" : "").bem;
    var _a = (0, react_1.useState)(false), isDropdownVisible = _a[0], setIsDropdownVisible = _a[1];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(cls), tabIndex: 0, onClick: function () {
            if (props.disabled)
                return;
            setIsDropdownVisible(!isDropdownVisible);
        }, onBlur: function () {
            setIsDropdownVisible(false);
        } }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "dropdown__content" }, { children: [props.value && props.value[props.selector] && ((0, jsx_runtime_1.jsx)("p", __assign({ className: "m-0 p-0" }, { children: props.value[props.selector] }))), !props.value && props.placeholder && ((0, jsx_runtime_1.jsx)("p", __assign({ className: "m-0 p-0 dropdown__placeholder" }, { children: props.placeholder }))), (0, jsx_runtime_1.jsx)("div", __assign({ className: "dropdown__icon" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { symbol: isDropdownVisible
                                ? IconSymbols_1.IconSymbols.ChevronUp
                                : IconSymbols_1.IconSymbols.ChevronDown }) }))] })), isDropdownVisible && !props.disabled && ((0, jsx_runtime_1.jsx)(Panel_1.Panel, __assign({ hasBorderRadius: true, hasShadow: true, className: "dropdown__options px-2 mt-1 ".concat(isDropdownVisible ? "dropdown__options--visible" : "") }, { children: props.items.map(function (item, idx) {
                    return react_1.default.Children.map(props.children, function (child) {
                        return react_1.default.cloneElement(child, __assign(__assign(__assign({}, child.props), item), { isSelected: props.value &&
                                props.value[props.selector] &&
                                props.value[props.selector] === item[props.selector], key: "".concat(props === null || props === void 0 ? void 0 : props.id, "Dropdown-").concat(idx), "data-test-id": "".concat(props === null || props === void 0 ? void 0 : props.id, "Dropdown-").concat(idx), onClick: function () {
                                if (props.disabled)
                                    return;
                                props.onItemSelected(item);
                            } }));
                    })[0];
                }) })))] })));
};
exports.Dropdown = Dropdown;
var DropdownOption = function (props) {
    var sProps = __assign({}, props);
    delete sProps.label;
    delete sProps.sublabel;
    delete sProps.isSelected;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({}, sProps, { className: "dropdown__option p-2" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "dropdown__option-icon" }, { children: props.isSelected && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: "mt-1", symbol: IconSymbols_1.IconSymbols.Check, size: enums_1.UiSizes.SM })) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "dropdown__option-label" }, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: "m-0 p-0" }, { children: props.label })), props.sublabel && ((0, jsx_runtime_1.jsx)("p", __assign({ className: "body-small m-0 dropdown__option-sublabel" }, { children: props.sublabel })))] }))] })));
};
exports.DropdownOption = DropdownOption;
